import { cn } from '../cn'
import type { ReactNode } from 'react'
import type { UseCollectionResult } from './useCollection'

export interface BulkSelectBarProps<RowT> {
  collection: UseCollectionResult<RowT>
  action?: ReactNode
  className?: string
}

export function BulkSelectBar<RowT>({ collection, action, className = '' }: BulkSelectBarProps<RowT>) {
  if (collection.selection.count === 0) return null

  return (
    <div className={cn('flex min-h-tap items-center gap-3 border-b border-line bg-mustard-tint px-4 text-sm text-strong', className)}>
      <span aria-live="polite">{collection.selection.count} selected</span>
      <button type="button" onClick={collection.selection.selectAllVisible} className="rounded-control px-2 text-xs font-semibold text-link hover:text-link-hover focus-visible:outline-none focus-visible:shadow-focus">
        Select visible
      </button>
      <button type="button" onClick={collection.selection.clear} className="rounded-control px-2 text-xs font-semibold text-ink-secondary hover:text-strong focus-visible:outline-none focus-visible:shadow-focus">
        Clear
      </button>
      {action && <div className="ml-auto">{action}</div>}
    </div>
  )
}
